import React, { useState } from 'react'
import MocaLogo from 'atoms/Logos'
import Icon from 'atoms/Icon'
import { routeList } from './routeList'
import { SideContainer, StyledNavLink, LogoContainer, NavChild, NavWithChildren, Children } from './styles'
import { permissionCheck } from 'helpers/permissionCheckHelper'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { withTheme } from 'styled-components'
import _ from 'lodash'

const Sidebar = ({ userLogin, isMobile, isShown, fnSwitch, history: { location, push }, theme }) => {
  const [routes, setRoutes] = useState(routeList)

  const setExpanded = ({ name }) => {
    const newRoutes = _.cloneDeep(routes)
    const index = newRoutes.findIndex(r => r.name === name)
    newRoutes[index].expanded = !newRoutes[index].expanded
    setRoutes(newRoutes)
  }

  return (
    <SideContainer isMobile={isMobile} isShown={isShown}>
      <LogoContainer>
        <MocaLogo onClick={() => push('/dash/user-list')} showPointer={true} />
      </LogoContainer>
      {routes.map((r, i) => {
        if (userLogin && userLogin.userDetail) {
          const { userDetail: { permissions } } = userLogin
          if (r.children) {
            const childPermissions = r.children.map(d => d.permission) || []
            const anyChildPermissions = childPermissions.some(d => permissionCheck(permissions, d))
            if (!anyChildPermissions) return null
            return (
              <NavWithChildren key={i}>
                <div
                  className={r.children.some(({ path }) => location.pathname.endsWith(path)) ? 'active' : ''}
                  onClick={() => setExpanded(r)}
                >
                  <Icon icon={r.icon} mr={'28px'} ml={'10%'} width={'20px'} />
                  {r.name}
                  <Icon icon="caret-down" mr={'20px'} ml={'auto'} width={'16px'} color={theme.mocaOrange} />
                </div>
                <Children expanded={r.expanded}>
                  {
                    r.children.map((child, c) => permissionCheck(permissions, child.permission) && (
                      <NavChild to={`/dash/${child.path}`} key={c} onClick={isMobile ? fnSwitch : null}>
                        <Icon icon={child.icon} mr={'28px'} ml={'10%'} width={'20px'} />
                        {child.name}
                      </NavChild>
                    ))
                  }
                </Children>
              </NavWithChildren>
            )
          } else if (permissionCheck(permissions, r.permission)) {
            return (
              <StyledNavLink to={`/dash/${r.path}`} key={i} onClick={isMobile ? fnSwitch : null}>
                <Icon icon={r.icon} mr={'28px'} ml={'10%'} width={'20px'} />
                {r.name}
              </StyledNavLink>
            )
          }
        }
        return null
      })
      }
    </SideContainer>
  )
}

const mapStateToProps = (state) => {
  return {
    userLogin: state.userLogin
  }
}

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      null
    )(Sidebar)
  )
)
